module.exports = __webpack_public_path__ + "assets/img/Coolabah-Turf-Service-Page.f3b62746.jpg";